import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { DataImportExportComponent } from './data-import-export.component';

const routes: Routes = [{ path: 'data-import-export', component: DataImportExportComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DataImportExportRoutingModule { }
